import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsync, cargarCatalogos, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { formatearFecha , formatearFechaMoment_a_String, formatearLabel } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

const Button = styled.button`
    height: 27px;
    line-height: 10px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

class FormCli10 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            clienteInput_sel: null,
            cliente_sel: null,
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            ult_transaccion: null,
            efectoDescProducto: null, //SOLO USADO EN TIPODESC = P; Permite seleccionar DESCUENTOS POR TODOS LOS PRODUCTOS O POR LINEAS DEFINIDAS

            //DatePicker
            fechaCreacion: null,
            fechaExpiracion: null,
            //TEXT
            codigoDescuento: '',
            porcentaje: 0,
            porcentajeLinea: 0,

            //COMBO
            formapagoCargado_sel: null, //Control que permite seleccionar que forma de pago cargar del cliente
            formapago_sel: 'CR',
            formapago_opt: [],
            tipodescuento_sel: null,
            tipodescuento_opt: [{value: 'P', label:'SOBRE CADA PROD.'},{value: 'T', label:'SOBRE TOTAL NETO'}],
            efectoDesc_sel:null,
            efectoDesc_opt:[{value: 'S', label:'MANTIENE DESC.'},{value: 'N', label:'NO MANT. DESC.'}], //S= Mantiene descuento en línea N=No mantiene el descuento en linea

            //RADIO
            efectoDescGen: null,

            //Parametro descuento general
            descuentoGeneral: '',

            //ASYNC
            tipocompra_sel: null,

            //Soporte para guardar la consulta por forma de pago CN y CR de 1 cliente
            arrayClienteCargado: [],

            //GRID
            gridLineas: [],
            coldefLineas: [                            
                            {   header: "Cod.",
                                field: "TipoCompra",
                                width: 37,
                                type: "string"
                            },
                            {   header: "Descripcion",
                                field: "Nombre",
                                width: 250,
                                type: "string"
                            },
                            {   header: "%",
                                field: "PDescuento",
                                width: 40,
                                type: "num_decimal"
                            },
                            {   header: "",
                                field: "eliminar",
                                width: 50,
                                type: "link_elim"                                                
                            }
                          ]
        };

        //GridOptions
        this.gridLineasOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
            }),
            onCellEditingStarted:((event)=> {
            })
        };
        this.addLinea = this.addLinea.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.porcentajeValid = this.porcentajeValid.bind(this);
        this.porcentajeLineaValid = this.porcentajeLineaValid.bind(this);
        this.guardarDescuentoCliente = this.guardarDescuentoCliente.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.cargarDescuentoCliente = this.cargarDescuentoCliente.bind(this);
        this.inactivarDescuentoCliente = this.inactivarDescuentoCliente.bind(this);
    }

    //OverControls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });

        if(name==='efectoDescProducto' && target.type ==='radio'){
            this.setState({gridLineas: []});
            if(value==='L'){
                this.setState({porcentaje: 0})
            }
        }
    }

    //REACT CICLE
    componentDidMount(){
        Promise.all([
            cargarCatalogos('FORMAPAGO'), this.cargarParametrosOtros('PARAM-VAINC'),          
            this.props.generar_LogAuditoriaIngresoForm('0110'), ])
        .then(([ formaPago, descGeneral ]) => {      
            this.setState({formapago_opt: formaPago,fechaCreacion: moment(), 
                descuentoGeneral: descGeneral[0].PorcDescuento, permiso: this.props.permiso})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0110');
    }

    //Getters Async
    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
          }
    }

    getOptions_TiposCompra(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('TIPOPRECIO', input, callback)
        }
    }

    porcentajeValid(){
        if(this.state.porcentaje){
            if(isNaN(this.state.porcentaje)===false){
                let porc = parseFloat(this.state.porcentaje,10);
                if(porc<0 || porc >100){
                    this.setState({porcentaje: 0})
                }
            }else{
                this.setState({porcentaje: 0});
            }
        }else{
            this.setState({porcentaje: 0});
        }
    }

    porcentajeLineaValid(){
        if(this.state.porcentajeLinea){
            if(isNaN(this.state.porcentajeLinea)===false){
                let porc = parseFloat(this.state.porcentajeLinea,10);
                if(porc<0 || porc >100){
                    this.setState({porcentajeLinea: 0})
                }
            }else{
                this.setState({porcentajeLinea: 0});
            }
        }else{
            this.setState({porcentajeLinea: 0});
        }
    }

    //ACTIONS BUTTONS
    guardarDescuentoCliente(){
        var errors = "";
        var proceder = true;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('01');

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+' -'+operacion.msg+'\n'
        }

        if(!this.state.clienteInput_sel){
            proceder = false;
            errors+=`- Ingrese un cliente\n`;
        }

        //VALIDA QUE EL CAMPO PORCENTAJE SEA MAYOR A 0 Y EL EFECTO POR DESC. PROD. SEA T (APLICADO A TODOS)
        if(parseFloat(this.state.porcentaje,10)===0 && this.state.efectoDescProducto==='T'){
            proceder = false;
            errors+=`- Ingrese un porcentaje mayor a 0\n`;
        }

        if(this.state.formapago_sel === null){
            proceder = false;
            errors+=`- Seleccione una forma de pago\n`;
        }

        if(this.state.tipodescuento_sel === null){
            proceder = false;
            errors+=`- Seleccione un tipo de descuento\n`;
        }else if(this.state.tipodescuento_sel==='T' & this.state.efectoDesc_sel===null){
            proceder = false;
            errors+=`- Seleccione un efecto de descuento\n`;
        }else if(this.state.tipodescuento_sel==='T' & this.state.efectoDescGen===null){
            proceder = false;
            errors+=`- Seleccione una accion para tratar al descuento general\n`;
        }

        if(this.state.tipodescuento_sel==='P' && this.state.efectoDescProducto===null){
            proceder = false;
            errors+=`- Seleccione modo de descuento en linea\n`;
        }else if(this.state.efectoDescProducto==='L' & this.state.gridLineas.length===0){
            proceder = false;
            errors+=`- Ingrese el detalle de descuentos por linea`;
        }

        if(this.state.fechaExpiracion!==null){
            var diff = this.state.fechaExpiracion.diff(moment(fechaProceso, 'DD/MM/YYYY'),'days' )
            if(diff < 0){
                proceder = false;
                errors+=`- La fecha minima a seleccionar es ${fechaProceso}`;
            }
        }

        if(proceder===true){

            data.Cliente = this.state.clienteInput_sel.value;
            data.FormaPago = this.state.formapago_sel;
            data.TipoDescuento = this.state.tipodescuento_sel;
            data.EfectoDescuentoLinea = this.state.efectoDesc_sel;
            data.EfectoDescuentoGeneral = this.state.efectoDescGen;
            data.EfectoDescProducto = this.state.efectoDescProducto;
            data.PDescuento = parseFloat(this.state.porcentaje).toFixed(2);
            data.FechaSistema = formatearFechaMoment_a_String(this.state.fechaCreacion);
            data.FechaExpiracion = this.state.fechaExpiracion!==null?formatearFechaMoment_a_String(this.state.fechaExpiracion):null;
            data.IdRegAudit = this.props.idRegAudit;
            data.Usuario = this.props.usuario;

            //ARRAY
            data.clienteDescLinea = this.state.efectoDescProducto==='L'?this.state.gridLineas:null;

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/descuentosporcliente':'/descuentosporcliente/'+this.state.codigoDescuento,
                data
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg)
                this.setState({ult_transaccion: response.data.codigo, operacion:'G'});
                this.limpiarPantalla('C');
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                          
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors);
        }
    }

    cargarDescuentoCliente(){
        var errors = "";
        var proceder = true;

        if(this.state.cliente_sel===null){
            proceder = false;
            errors+=' - Seleccione un cliente a cargar'
        }

        if(proceder===true){
            let config_request = {
                method: 'GET',
                url: '/descuentosporcliente?cliente='+this.state.cliente_sel.value
            }

            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                let data = response.data;              
                if(data.length===1){
                    this.cargarClienteArray(data[0]);
                }else if(data.length===2){
                    this.setState({arrayClienteCargado: data},()=>{
                        this.clienteFormaPago_sel({value: 'CR'}); //VALOR CARGADO POR DEFECTO CREDITO
                    });
                }
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                          
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors);
        }
    }

    cargarClienteArray(data){
        this.limpiarPantalla('A');
        this.setState({codigoDescuento: data.DescuentoId, formapago_sel: data.FormaPago,
            tipodescuento_sel: data.TipoDescuento, porcentaje: data.PDescuento, operacion: 'M',
            efectoDescProducto: data.EfectoDescProducto})
        
        if(data.cliDet!==null){
            let item = {};
            item.value = data.cliDet.Cliente;
            item.label = `${data.cliDet.Nombre} (${item.value})`;
            this.setState({clienteInput_sel: item})
        }

        if(data.TipoDescuento==='T'){
            this.setState({efectoDesc_sel: data.EfectoDescuentoLinea, efectoDescGen: data.EfectoDescuentoGeneral});
        }
        
        if(data.FechaExpiracion!==null){
            this.setState({fechaExpiracion: moment(formatearFecha(data.FechaExpiracion),'DD/MM/YYYY')})
        }

        if(data.EfectoDescProducto==='L'){
            let lineas = [];
            data.detLineas.forEach((LINEA)=>{
                let item = {};
                item.TipoCompra = LINEA.TipoCompra;
                item.Nombre = LINEA.tipoDet!==null?LINEA.tipoDet.Descripcion:'N/A';
                item.PDescuento = LINEA.PDescuento;
                lineas.push(item);
            })
            this.setState({gridLineas: lineas})
        }
    }

    inactivarDescuentoCliente(){
        var errors = "";
        var proceder = true;

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+' -'+operacion.msg+'\n'
        }

        if(proceder===true){
            let config_request = {
                method: 'DELETE',
                url: '/descuentosporcliente/'+this.state.codigoDescuento,
                headers: {'idregaudit': this.props.idRegAudit, 'operacion':this.props.usuario}
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg)
                this.setState({ult_transaccion: response.data.codigo, operacion:'G'});
                this.limpiarPantalla('C');
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                          
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors)
        }

    }

    //Methods
    limpiarPantalla(params){
        this.setState({operacion: 'G', clienteInput_sel: null, cliente_sel: null, fechaCreacion: moment(), codigoDescuento: '',
        porcentaje: 0, formapago_sel: 'CR', tipodescuento_sel: null, efectoDesc_sel:null, fechaExpiracion: null, efectoDescGen: null,
        efectoDescProducto: null, porcentajeLinea: 0, tipocompra_sel: null}) 

        if(params==='C'){
            this.setState({arrayClienteCargado: [], formapagoCargado_sel: null})            
        }        
    }

    cargarParametrosOtros(parametro){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion='+parametro)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject(err.toString());
            });
        });
    }

    changeTipoDesc(value){
        this.setState({tipodescuento_sel: value!==null?value.value:null, 
        efectoDesc_sel: null, efectoDescGen: null, efectoDescProducto:null})
    }

    addLinea(){
        var errors = "";
        var proceder = true;

        if(parseFloat(this.state.porcentajeLinea,10)===0 || parseFloat(this.state.porcentajeLinea,10)>100){
            proceder = false;
            errors+=`- Ingrese un porcentaje mayor a 0\n`;
        }
        
        if(this.state.tipocompra_sel===null){
            proceder = false;
            errors+=`- Seleccione una categoría`;
        }else if(this.lineasRepetidas(this.state.tipocompra_sel.value)===true){
            proceder = false;
            errors+=`- No se pueden repetir las categorías`;
        }

        if(proceder===true){
            let item = {};

            item.TipoCompra = this.state.tipocompra_sel.value;
            item.Nombre = formatearLabel(this.state.tipocompra_sel.label);
            item.PDescuento = parseFloat(this.state.porcentajeLinea).toFixed(2);
            this.setState({gridLineas: this.immutablePush(this.state.gridLineas, item)},()=>{
                this.setState({porcentajeLinea: '', tipocompra_sel:null})
            })
        }else{
            alert(errors)
        }
    }

    lineasRepetidas(item){
        let repetido = false;
        if(this.state.gridLineas.length > 0){
            this.state.gridLineas.forEach((LINEA)=>{
                if(LINEA.TipoCompra === item){
                    repetido = true;
                }
            })
        }

        return repetido;
    }

    methodFromParent(id, datos_fila){
        var mensaje;
        mensaje = window.confirm("¿Desea eliminar el registro?");
        if(mensaje){
            this.setState({ gridLineas: this.immutableDelete(this.state.gridLineas, id)});
        } 
    }

    //Op Arrays Inmutables
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    //Forma Pago cuando cliente tiene las 2 formas de pago ingresadas CR Y CN
    clienteFormaPago_sel(value){
        let cli_selected = {};
        this.setState({formapagoCargado_sel: value!==null?value.value:null})
        if(value!==null){
            this.state.arrayClienteCargado.forEach((CLI)=>{
                if(CLI.FormaPago === value.value){
                    cli_selected = CLI;
                }
            })
            this.cargarClienteArray(cli_selected);
        }        
    }
    
    render(){
        return(
            <ContenedorForm porc_ancho={65}>
             <HeaderForm>
                <TituloForm>Descuentos por cliente</TituloForm>
                <LabelCabecera>Ult. cli.: {this.state.ult_transaccion}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='5' alto='50'>
                        <Row>
                            <ContainerCol className='col-sm-1'>
                                <LabelForm>Cliente:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-6'>
                                <div className="input-group">                                    
                                    <ReactSelectAsync value={this.state.cliente_sel}  func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value!==null?value:null})}}/>
                                    <span className="input-group-btn">
                                        <Button type="button" className='btn btn-default' onClick={this.cargarDescuentoCliente}><i className='fa fa-search' aria-hidden='true'/></Button>
                                    </span>
                                </div>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2' isInvisible={this.state.arrayClienteCargado.length===2?false:true}>
                                <LabelForm>Forma pago a cargar:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-3' isInvisible={this.state.arrayClienteCargado.length===2?false:true}>
                                <ReactSelect options={ this.state.formapago_opt } value={this.state.formapagoCargado_sel} func_onChange={(value)=>{this.clienteFormaPago_sel(value)}}/>   
                            </ContainerCol>                              
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-11'>
                            <ContainerCol className='col-sm-1' margen_arriba='5'> 
                                <LabelForm>Asg. Cliente:</LabelForm>
                            </ContainerCol> 
                            <ContainerCol className='col-sm-6' margen_arriba='5'>                              
                                <ReactSelectAsync value={this.state.clienteInput_sel} disabled={this.state.operacion==='M'?true:false}  func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({clienteInput_sel: value!==null?value:null})}}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-push-1 col-sm-2' margen_arriba='5'>
                                <LabelForm margen_izq='3'>Descuento Id:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-push-1 col-sm-2' margen_arriba='5'>
                                <InputText margen_izq='28' ancho='143' name='codigoDescuento' value={this.state.codigoDescuento} disabled={true} type="text" className='form-control input-sm'/>            
                            </ContainerCol>  
                        </ContainerCol>
                    </Row>
                    <Row> 
                        <ContainerCol className='col-sm-4'>
                            <ContainerCol className='col-sm-3' margen_arriba='5'>
                                <LabelForm>Forma pago:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-9' margen_arriba='5'>
                                <ReactSelect options={ this.state.formapago_opt } value={this.state.formapago_sel} 
                                func_onChange={(value)=>{this.setState({formapago_sel: value!==null?value.value:null})}}
                                disabled={this.state.arrayClienteCargado.length===2?true:false}/>   
                            </ContainerCol>
                        </ContainerCol>
                        
                        <ContainerCol className='col-sm-4'>   
                            <ContainerCol className='col-sm-3' margen_arriba='7'>
                                <LabelForm>Tipo desc.:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-9' margen_arriba='7'>
                                <ReactSelect options={ this.state.tipodescuento_opt } value={this.state.tipodescuento_sel} func_onChange={(value)=>{this.changeTipoDesc(value)}}/>
                            </ContainerCol>                             
                        </ContainerCol>

                        <ContainerCol className='col-sm-4'>
                            <ContainerCol className='col-sm-4' margen_arriba='7'>
                                <LabelForm>Efecto desc. Linea:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_arriba='7'>
                                <ReactSelect options={ this.state.efectoDesc_opt } disabled={this.state.tipodescuento_sel===null || this.state.tipodescuento_sel==='P'?true:false} value={this.state.efectoDesc_sel} func_onChange={(value)=>{this.setState({efectoDesc_sel: value!==null?value.value:null})}}/>
                            </ContainerCol>                            
                        </ContainerCol>
                    </Row>
                    <Row>                     
                        <ContainerCol className='col-sm-4'> 
                            <ContainerCol className='col-sm-3' >
                                <LabelForm>Porc.:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-9' >
                                <InputText name='porcentaje' value={this.state.porcentaje} className='form-control input-sm' 
                                onChange={this.actualizarCampos} maxLength='6' onBlur={this.porcentajeValid}
                                disabled={this.state.tipodescuento_sel==='P' && this.state.efectoDescProducto==='L'?true:false}/>
                            </ContainerCol>
                        </ContainerCol>
                        
                        <ContainerCol className='col-sm-4'> 
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Fecha exp.:</LabelForm>  
                            </ContainerCol> 
                            <ContainerCol className='col-sm-9'>
                                <PickerFecha fechaSeleccionada={this.state.fechaExpiracion} func_onChange={(fechaEscogida)=>{this.setState({fechaExpiracion: fechaEscogida});}}/> 
                            </ContainerCol>
                        </ContainerCol>

                        <ContainerCol className='col-sm-4' isInvisible={this.state.tipodescuento_sel!=='T'?true:false}> 
                            <ContainerCol className='col-sm-4' >
                                <LabelForm>% General:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' >
                                <InputText name='descuentoGeneral' value={this.state.descuentoGeneral} disabled={true} type="number" className='form-control input-sm'/>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    <Row>                        
                        <ContainerCol className='col-sm-4' isInvisible={this.state.tipodescuento_sel!=='T'?true:false}> 
                            <LabelSub><Radio name="efectoDescGen" type='radio' value='R' onChange={this.actualizarCampos} checked={this.state.efectoDescGen==='R'?true:false}/>{` Reemplazo al % General  `}</LabelSub> {/*${this.state.efectoDescGen==='R'?this.state.porcentaje+'%':''}*/}
                            <LabelSub><Radio name="efectoDescGen" type='radio' value='A' onChange={this.actualizarCampos} checked={this.state.efectoDescGen==='A'?true:false}/>{` Adiciona al % General `}</LabelSub> {/*${this.state.efectoDescGen==='A'?(parseFloat(this.state.descuentoGeneral,10)+parseFloat(this.state.porcentaje)).toFixed(2)+'%':''}*/}
                        </ContainerCol>                        
                    </Row> 
                    <Row isInvisible={this.state.tipodescuento_sel!=='P'?true:false} margen_arriba='5'>
                        <ContainerCol className='col-sm-6 col-sm-offset-6 col-sm-pull-6'> 
                            <LabelForm>{'Modo de descuento en linea:'}</LabelForm>
                            <LabelForm className='radio-inline col-sm-push-1'>
                                <Radio name="efectoDescProducto" type='radio' value='T' onChange={this.actualizarCampos} checked={this.state.efectoDescProducto==='T'?true:false}/>{` Todas las lineas. `}
                            </LabelForm>
                            <LabelForm className='radio-inline col-sm-push-1'>
                                <Radio name="efectoDescProducto" type='radio' value='L' onChange={this.actualizarCampos} checked={this.state.efectoDescProducto==='L'?true:false}/>{` Por linea  `}
                            </LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row isInvisible={this.state.tipodescuento_sel!=='P' || this.state.efectoDescProducto!=='L'?true:false} margen_arriba='5'>
                        <ContainerCol className='col-sm-6' margen_arriba='12'> 
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Categoría:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-9'>
                                <ReactSelectAsync value={this.state.tipocompra_sel} func_loadOptions={this.getOptions_TiposCompra} func_onChange={(value)=>{this.setState({tipocompra_sel: value!==null?value:null})}}/>
                            </ContainerCol>
                       
                            <ContainerCol className='col-sm-3 col-sm-pull-3' margen_arriba='7'>
                                <LabelForm>Porcentaje:</LabelForm> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-4 col-sm-pull-3' margen_arriba='7'>
                                <div className='input-group'>
                                    <InputText name='porcentajeLinea' value={this.state.porcentajeLinea} className='form-control input-sm' onChange={this.actualizarCampos} maxLength='6' onBlur={this.porcentajeLineaValid}/>
                                    <span className='input-group-btn'>
                                        <ButtonUnion type="button" className='btn btn-sm btn-success' onClick={this.addLinea}><i className='fa fa-plus' aria-hidden='true'/></ButtonUnion>
                                    </span>
                                </div>
                            </ContainerCol>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>                            
                            <AgGridRender altura='128px' data={this.state.gridLineas} columnas={this.state.coldefLineas}
                            gridOptions={this.gridLineasOptions} onGridReady={this.onGridLineasReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba='7'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={false} onClick={this.guardarDescuentoCliente}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('C')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.inactivarDescuentoCliente}><i className='fa fa-window-close  fa-lg'/> Inactivar</button>         
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                            cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCli10);